import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../store";
import { useCallback } from "react";
import { emitEvent } from "../event-emitter";
import { EVENT_CLICK_POLICY_AGREE } from "../constants";
import { setPolicyAgreeStatus } from "../reducers/client/client.actions";



export const usePolicyAgree = () => {
	const { policyAgree: policyStatus, policyAgreementMode } = useSelector((state: RootState) => state.client) || {};
	const dispatch = useDispatch();

	const setPolicyAgree = useCallback(() => {
		emitEvent(EVENT_CLICK_POLICY_AGREE);
		dispatch(setPolicyAgreeStatus());
	}, [dispatch]);

	return { policyStatus, policyAgreementMode, setPolicyAgree }
}